import React, { useState, useContext, useEffect } from "react";
import { ServicesContainer, MainDesc } from "./CounterElements";
import * as PA from "./CounterElements";
import { connect } from "react-redux";
import * as actionTypes from "../../../../store/actions";
import { withRouter } from "react-router-dom";
import CountUp from "react-countup";
import ScrollTrigger from "react-scroll-trigger";
import { LanguageContext } from "../../../../utils/language/Language";
import axios from "../../../../axios"

const Counter = ({ userData, history }) => {
  const [counterOn, setCounterOn] = useState(false);

  const [selectedLanguage, setSelectedLanguage] = useState(window.localStorage.getItem("rcml-lang") || "en");
  const { dictionary } = useContext(LanguageContext);
  const [countData, setCountData] = useState([])

  const getCount = async () => {
    try {
      const { data } = await axios.get('/home-counts');
      // console.log(data);
      setCountData(data.data)
    }
    catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    getCount();
  }, [])
  return (
    <ServicesContainer id="services">
      <PA.InnerContainer>
        <ScrollTrigger style={{width: "100%", display: "flex", justifyContent: "center"}} onEnter={() => setCounterOn(true)} onExit={() => setCounterOn(false)}>
          {/* <PA.CounterWrap> */}
            <PA.CounterContent>
              <PA.CountBox>
                <PA.CountNo>{counterOn && <CountUp start={0} end={countData?.property} duration={5} delay={0} />}</PA.CountNo>
                <PA.CountText>{dictionary.menzilString.Listing}</PA.CountText>
              </PA.CountBox>
              <PA.CountBox>
                <PA.CountNo>{counterOn && <CountUp start={0} end={countData?.location} duration={5} delay={0} />}</PA.CountNo>
                <PA.CountText>{dictionary.menzilString.Locations}</PA.CountText>
              </PA.CountBox>
              <PA.CountBox>
                <PA.CountNo>{counterOn && <CountUp start={0} end={countData?.buyer} duration={5} delay={0} />}</PA.CountNo>
                <PA.CountText>{dictionary.menzilString.Customers}</PA.CountText>
              </PA.CountBox>
              <PA.CountBox>
                <PA.CountNo>{counterOn && <CountUp start={0} end={countData?.agent} duration={5} delay={0} />}</PA.CountNo>
                <PA.CountText>{dictionary.menzilString.Agents}</PA.CountText>
              </PA.CountBox>
            </PA.CounterContent>
          {/* </PA.CounterWrap> */}
        </ScrollTrigger>
      </PA.InnerContainer>
    </ServicesContainer>
  );
};

// export default Services;
const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Counter));
